import React, { useState } from "react";
import { Form, Input, Button, message, Upload, Select } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "@/axios/axiosInstance";
import { UploadOutlined } from "@ant-design/icons";
import "./Verify.scss";

const { Option } = Select;

const Verify = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [handHeldImage, setHandHeldImage] = useState(null);
  const [verifyCode, setVerifyCode] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [userAuthId, setUserAuthId] = useState("");

  // 获取验证码
  const handleGetCode = async () => {
    try {
      const phone = JSON.parse(sessionStorage.getItem("user")).phone || "";
      if (!phone) {
        message.error("获取手机号失败");
        return;
      }

      setCountdown(60);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      const response = await axiosInstance.get(
        `/account/sendVerifyCode?phone=${phone}`
      );
      if (response.data.code === 10000) {
        message.success("验证码已发送");
      } else {
        message.error(response.data.msg || "发送验证码失败");
      }
    } catch (error) {
      console.error("发送验证码失败:", error);
      message.error("发送验证码失败");
    }
  };

  // 自定义上传方法
  const customUpload = async ({ file, type }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);
      if (userAuthId) {
        formData.append("userAuthId", userAuthId);
      }

      const response = await axiosInstance.post("/user/auth/file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.code === 10000) {
        // 保存上传后的图片信息
        if (type === 1) {
          setFrontImage(response.data.data.url);
        } else if (type === 2) {
          setBackImage(response.data.data.url);
        } else if (type === 3) {
          setHandHeldImage(response.data.data.url);
        }

        // 保存 userAuthId，用于后续上传
        if (response.data.data.userAuthId) {
          setUserAuthId(response.data.data.userAuthId);
        }

        message.success("上传成功");
      } else {
        message.error(response.data.msg || "上传失败");
      }
    } catch (error) {
      console.error("上传失败:", error);
      message.error("上传失败");
    }
  };

  // 修改 uploadProps
  const getUploadProps = (type) => ({
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("只能上传 JPG/PNG 格式的图片!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("图片大小不能超过 2MB!");
        return false;
      }

      // 调用自定义上传
      customUpload({ file, type });
      return false;
    },
    maxCount: 1,
    showUploadList: {
      showPreviewIcon: true,
      showRemoveIcon: true,
    },
  });

  // 修改提交方法
  const handleSubmit = async (values) => {
    if (!frontImage || !backImage || !handHeldImage) {
      message.warning("请上传身份证正面照、反面照和手持身份证照片");
      return;
    }

    if (!values.verifyCode) {
      message.warning("请输入手机验证码");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("idType", values.idType);
      formData.append("name", values.name);
      formData.append("idNumber", values.idNumber);
      formData.append("frontImage", frontImage);
      formData.append("backImage", backImage);
      formData.append("handHeldImage", handHeldImage);
      formData.append("verifyCode", values.verifyCode);
      if (userAuthId) {
        formData.append("userAuthId", userAuthId);
      }

      const response = await axiosInstance.post("/account/verify", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.code === 10000) {
        message.success("实名认证提交成功，请等待审核");
        navigate("/personal/finance/recharge");
      } else {
        message.error(response.data.msg || "认证失败");
      }
    } catch (error) {
      console.error("实名认证失败:", error);
      message.error("实名认证失败");
    } finally {
      setLoading(false);
    }
  };

  console.log(sessionStorage.getItem("user"));
  return (
    <div className="verify-container">
      <div className="title">实名认证</div>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="verify-form"
        initialValues={{ idType: "身份证" }}
      >
        <Form.Item
          label="证件类型"
          name="idType"
          rules={[{ required: true, message: "请选择证件类型" }]}
        >
          <Select disabled>
            <Option value="身份证">身份证</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="真实姓名"
          name="name"
          rules={[
            { required: true, message: "请输入真实姓名" },
            { pattern: /^[\u4e00-\u9fa5]{2,6}$/, message: "请输入2-6个汉字" },
          ]}
        >
          <Input placeholder="请输入真实姓名" maxLength={6} />
        </Form.Item>

        <Form.Item
          label="证件号"
          name="idNumber"
          rules={[
            { required: true, message: "请输入身份证号" },
            {
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: "请输入正确的身份证号",
            },
          ]}
        >
          <Input placeholder="请输入身份证号" maxLength={18} />
        </Form.Item>

        <Form.Item label="请上传身份证照片：">
          <div className="upload-area">
            <div className="upload-item">
              <Upload {...getUploadProps(1)} className="upload-box">
                <div className="upload-content">
                  <UploadOutlined className="upload-icon" />
                  <div className="upload-text">上传身份证正面照（2M以内）</div>
                  {frontImage && (
                    <img
                      src={frontImage}
                      alt="正面照"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                </div>
              </Upload>
            </div>
            <div className="upload-item">
              <Upload {...getUploadProps(2)} className="upload-box">
                <div className="upload-content">
                  <UploadOutlined className="upload-icon" />
                  <div className="upload-text">上传身份证背面照（2M以内）</div>
                  {backImage && (
                    <img
                      src={backImage}
                      alt="背面照"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                </div>
              </Upload>
            </div>
            <div className="upload-item">
              <Upload {...getUploadProps(3)} className="upload-box">
                <div className="upload-content">
                  <UploadOutlined className="upload-icon" />
                  <div className="upload-text">
                    上传手持身份证照片（2M以内）
                  </div>
                  {handHeldImage && (
                    <img
                      src={handHeldImage}
                      alt="手持照"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                </div>
              </Upload>
            </div>
          </div>
        </Form.Item>

        <div className="verify-phone">
          <div className="phone-label">验证手机：</div>
          <div className="phone-number">
            {JSON.parse(sessionStorage.getItem("user")).phone ||
              "未获取到手机号"}
          </div>
        </div>

        <Form.Item
          label="手机验证码"
          name="verifyCode"
          rules={[{ required: true, message: "请输入验证码" }]}
        >
          <div className="verify-code-section">
            <Input placeholder="请输入验证码" maxLength={6} />
            <Button
              type="primary"
              onClick={handleGetCode}
              disabled={countdown > 0}
              className="code-button"
            >
              {countdown > 0 ? `${countdown}s后重新获取` : "点击获取"}
            </Button>
          </div>
        </Form.Item>

        <Form.Item className="agreement-section">
          <div className="agreement">
            <input type="checkbox" checked readOnly />
            <span>
              我已阅读并同意{" "}
              <a
                href="/agreements/terms.html"
                target="_blank"
                className="agreement-link"
              >
                《用户协议》
              </a>
              和
              <a
                href="/agreements/privacy.html"
                target="_blank"
                className="agreement-link"
              >
                《隐私政策》
              </a>
            </span>
          </div>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="submit-btn"
          >
            提交验证
          </Button>
        </Form.Item>
      </Form>

      <div className="notice-section">
        <div className="notice-title">注意事项：</div>
        <ol>
          <li>身份证照片必须为原件拍摄，不能是复印件</li>
          <li>身份证必须在有效期内，照片需完整清晰</li>
          <li>上传的照片必须为本人身份证，如有作假将承担相应责任</li>
          <li>请确保身份证号码和"真实姓名"与身份证件信息一致</li>
          <li>认证成功后将无法修改，请确保信息准确</li>
        </ol>
      </div>
    </div>
  );
};

export default Verify;
